import { configureStore } from "@reduxjs/toolkit";
import blogReducer from "../features/blogSlice";
import authSlice from "../features/authSlice";
import storage from 'redux-persist/lib/storage' // defaults to localStorage for web
import persistReducer from "redux-persist/es/persistReducer";
import { persistStore } from "redux-persist";
import newsReducer from "../features/newsSlice";

const persistConfig = {
  key: "root",
  storage,
};
const persistedReducer = persistReducer(persistConfig, authSlice);


export const store = configureStore({
  reducer: {
    blog: blogReducer,
    auth:persistedReducer,
    news:newsReducer
  },
});
export const persistor = persistStore(store);
